/** 组织同步记录展示文案（与后端 org_sync_labels.py 一致） */

const ORG_SYNC_SOURCE_LABEL: Record<string, string> = {
  external: '外部同步',
  import: 'Excel 导入',
  manual: '手工录入',
  ecology: '泛微 e-cology',
  ldap: 'LDAP 目录',
  oa: 'OA 系统',
}

const ORG_SYNC_TRIGGER_LABEL: Record<string, string> = {
  push: '手动推送',
  pull: '接口拉取',
  import: 'Excel 导入',
}

export function orgSyncSourceLabel(source: string, trigger?: string): string {
  const key = (source || '').trim().toLowerCase()
  if (ORG_SYNC_SOURCE_LABEL[key]) return ORG_SYNC_SOURCE_LABEL[key]
  const t = (trigger || '').trim().toLowerCase()
  if (t === 'import') return 'Excel 导入'
  if (t === 'pull') return '接口拉取'
  if (t === 'push') return '手动推送'
  return '其他来源'
}

export function orgSyncTriggerLabel(trigger: string): string {
  const key = (trigger || '').trim().toLowerCase()
  return ORG_SYNC_TRIGGER_LABEL[key] || '其他方式'
}
